import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { Loading03Icon } from '@/components/ui/icon/glyphs';
export function NudgeLoading() {
  const $ = _c(5);
  const t = useTranslations("launchpad.duplicateNudge");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon icon={Loading03Icon} className="size-4 animate-spin motion-reduce:animate-none text-foreground-secondary" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("checking");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-3 rounded-panel-row border bg-background-tertiary px-4 py-3">{t0}<span className="text-caption text-foreground-secondary">{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}